export default "__VITE_ASSET__BcDxZOyn__"